import type { AppSettings } from "@/services/types";

/** Seed application settings — business identity, numbering and group defaults. */
export const MOCK_SETTINGS: AppSettings = {
  business: {
    businessName: "Gupta Chit Fund",
    proprietor: "Ramesh Gupta",
    address: "Shop 12, Patel Market, Main Road",
    city: "Indore",
    state: "Madhya Pradesh",
    pinCode: "452001",
    primaryPhone: "+91 98100 12345",
    alternatePhone: "+91 731 254 8899",
    email: "guptachitfund@example.in",
    website: "www.guptachitfund.in",
    registrationNumber: "GSTIN 23AABFG1123K1Z5",
    logoUrl: "",
  },
  numbering: {
    rules: [
      { id: "member_code", prefix: "MEM", padding: 4, next: 76, resetAnnually: false },
      { id: "group_code", prefix: "KGT", padding: 3, next: 14, resetAnnually: false },
      { id: "receipt", prefix: "RCPT", padding: 5, next: 1042, resetAnnually: true },
      { id: "payout_voucher", prefix: "PV", padding: 5, next: 128, resetAnnually: true },
    ],
  },
  defaults: {
    reservedCycle: 2,
    commissionType: "none",
    commissionValue: 0,
    gracePeriodDays: 5,
    lateFee: 50,
    lateFeeIsPercent: false,
    lateFeePerDay: false,
    bidStep: 100,
    blockOverdueBidding: true,
    dividendTiming: "same_month",
    auctionDay: 5,
    dueDay: 10,
  },
  updatedBy: "u-super",
  updatedAt: "2026-08-20T10:30:00.000Z",
};